'use client';

import { useUI } from '@/context/UIContext';
import { Moon, Sun } from 'lucide-react';
import { Button } from './button';

interface ThemeToggleProps {
  variant?: 'default' | 'outline' | 'ghost';
  size?: 'icon' | 'default' | 'sm' | 'lg';
  className?: string;
}

export function ThemeToggle({ 
  variant = 'outline', 
  size = 'icon',
  className = '' 
}: ThemeToggleProps) {
  const { theme, toggleTheme } = useUI();

  return (
    <Button
      variant={variant}
      size={size}
      onClick={toggleTheme}
      className={`${className}`}
      aria-label="Toggle theme"
    >
      {theme === 'dark' ? (
        <Sun className="h-[1.2rem] w-[1.2rem]" />
      ) : (
        <Moon className="h-[1.2rem] w-[1.2rem]" />
      )}
      <span className="sr-only">
        {theme === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'}
      </span>
    </Button>
  );
}